import { render, staticRenderFns } from "./CommunicationToggle.vue?vue&type=template&id=59021002"
import script from "./CommunicationToggle.vue?vue&type=script&lang=js"
export * from "./CommunicationToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports